export const openDemoModal = () => {
  window.dispatchEvent(new CustomEvent("tt:open-contact-modal"));
};

export const closeDemoModal = () => {
  window.dispatchEvent(new CustomEvent("tt:close-contact-modal"));
};
